import { Component, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { Icon } from 'app/shared/icon';

/* eslint-disable @angular-eslint/component-selector */
@Component({
    selector: `
        button[stby-button], a[stby-button],
        button[stby-button-primary], a[stby-button-primary],
        button[stby-button-success], a[stby-button-success],
        button[stby-button-danger], a[stby-button-danger],
        button[stby-button-secondary], a[stby-button-secondary],
        button[stby-button-basic], a[stby-button-basic],
        button[stby-button-tertiary], a[stby-button-tertiary],
    `,
    styleUrl: './button.scss',
    templateUrl: './button.html',
    imports: [MatProgressSpinnerModule, Icon],
})
export class Button {
    readonly arrow = input<string>();
    readonly saving = input(false);
}
